// tv/remote-config.js — TV-native remote command mapping (brand-aware).
//
// Apple TV remote commands fire against remote.apple_tv_<room> with a
// canonical pyatv vocabulary ('home', 'menu', 'select', etc.). TV-side
// commands need PER-BRAND service routing — not just different button
// names, but DIFFERENT services and DIFFERENT target entities:
//
//   LG WebOS (Pavilion):
//     - No `remote.*` entity at all (verified 2026-05-25).
//     - Service: webostv.button
//     - Target:  entity_id = media_player.pavilion_tv
//     - Field name: `button` (not `command`)
//     - Vocabulary: UPPERCASE — HOME / MENU / BACK / UP / DOWN / LEFT
//       / RIGHT / ENTER.
//
//   Sony BRAVIA via androidtv_remote (Office, Rumpus):
//     - remote.<room>_tv entity exists.
//     - Service: remote.send_command
//     - Target:  entity_id = remote.<room>_tv
//     - Field name: `command`
//     - Vocabulary: Android keyevent names — DPAD_UP / DPAD_DOWN /
//       DPAD_LEFT / DPAD_RIGHT / DPAD_CENTER (for OK), HOME, BACK,
//       MENU.
//
// Earlier (2026-05-24) seed assumed `remote.send_command` worked
// universally and used `remote.<room>_tv` for all rooms — silently no-
// op'd on Pavilion because LG's HA integration doesn't expose a
// remote entity. Sony BRAVIA names were also wrong (Confirm/Return
// PascalCase doesn't match the androidtv_remote vocabulary). Both
// fixed 2026-05-25.

export const TV_REMOTE = {
  pavilion: {
    service: 'webostv.button',
    entityId: 'media_player.pavilion_tv',
    field: 'button',
    cmds: {
      home: 'HOME', menu: 'MENU', back: 'BACK',
      up: 'UP', down: 'DOWN', left: 'LEFT', right: 'RIGHT',
      ok: 'ENTER',
    },
  },
  office: {
    service: 'remote.send_command',
    entityId: 'remote.office_tv',
    field: 'command',
    cmds: {
      home: 'HOME', menu: 'MENU', back: 'BACK',
      up: 'DPAD_UP', down: 'DPAD_DOWN', left: 'DPAD_LEFT', right: 'DPAD_RIGHT',
      ok: 'DPAD_CENTER',
    },
  },
  rumpus: {
    service: 'remote.send_command',
    entityId: 'remote.rumpus_tv',
    field: 'command',
    cmds: {
      home: 'HOME', menu: 'MENU', back: 'BACK',
      up: 'DPAD_UP', down: 'DPAD_DOWN', left: 'DPAD_LEFT', right: 'DPAD_RIGHT',
      ok: 'DPAD_CENTER',
    },
  },
};

export function dispatchTVRemote(hass, roomId, action) {
  const cfg = TV_REMOTE[roomId];
  if (!cfg) {
    console.warn('[tv] no TV remote config for room', { roomId });
    return;
  }
  const cmd = cfg.cmds[action];
  if (!cmd) {
    console.warn('[tv] no TV remote command mapping', { roomId, action });
    return;
  }
  if (!hass?.callService) return;
  const [domain, name] = cfg.service.split('.');
  hass.callService(domain, name, {
    entity_id: cfg.entityId,
    [cfg.field]: cmd,
  });
}
